var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"mt-2 mr-2",attrs:{"small":""},domProps:{"textContent":_vm._s(_vm.icon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }